var exports = {
  "IW": "TypingUsers.module__typing___ZlNEUC",
  "Xh": "TypingUsers.module__username___ZlNEUC",
  "V": "TypingUsers.module__composerStatus___ZlNEUC",
  "sM": "TypingUsers.module__srOnly___ZlNEUC",
  "xP": "TypingUsers.module__measure___ZlNEUC",
};

module.exports = exports;
